import { render } from "./FileManager.vue?vue&type=template&id=486f696c&scoped=true"
import script from "./FileManager.vue?vue&type=script&lang=js"
export * from "./FileManager.vue?vue&type=script&lang=js"

import "./FileManager.vue?vue&type=style&index=0&id=486f696c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486f696c"],['__file',"resources/assets/components/Tenders/FileManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "486f696c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('486f696c', __exports__)) {
    api.reload('486f696c', __exports__)
  }
  
  module.hot.accept("./FileManager.vue?vue&type=template&id=486f696c&scoped=true", () => {
    api.rerender('486f696c', render)
  })

}


export default __exports__